import { HttpClient } from "@angular/common/http";
import { IResult } from "app/common/interfaces";
import { AbstractService } from "app/services/abstract.service";
import { environment as env } from "../../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import AddressAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/common/embedded/address/address.entity";
import { ICreateBusinessPartnerAddress } from "app/modules/components/business-partners/business-partner/business-partner-address-modal/interfaces/create-business-partner-address.interface";
import { IUpdateBusinessPartnerAddress } from "app/modules/components/business-partners/business-partner/business-partner-address-modal/interfaces/update-business-partner-address.interface";
const apiUrl = env.API_CONFIGURATION_URL;
const moduleName = "company_address";

@Injectable({
  providedIn: "root",
})
export class CompanyAddressService extends AbstractService<
AddressAttributes,
ICreateBusinessPartnerAddress,
IUpdateBusinessPartnerAddress
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findByCompanyId(companyId: string): Observable<IResult<AddressAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${companyId}`;
    return this.http.get<IResult<AddressAttributes>>(API_URL);
  }
}